import { PublishedDocPageVisitsEntry, SupernovaException } from "@supernova-studio/model";
import {
  DTODocumentationAnalyticsTimeFrame,
  DTOPublishedDocAnalyticsComparisonData,
  DTOPublishedDocPageAnalyticsComparisonData,
} from "../../dto";
import { documentationAnalyticsToGlobalDto } from "./page-visits-to-dto";

//
// Page analytics
//

type PageAnalyticsInput = {
  pagePersistentId: string;
  priorDataPoints: PublishedDocPageVisitsEntry[];
  currentDataPoints: PublishedDocPageVisitsEntry[];
  timeFrame: DTODocumentationAnalyticsTimeFrame;
};

export function documentationAnalyticsToPageComparisonDto(
  input: PageAnalyticsInput
): DTOPublishedDocPageAnalyticsComparisonData {
  const { pagePersistentId } = input;

  function validateDataPoint(dataPoint: PublishedDocPageVisitsEntry) {
    if (dataPoint.pagePersistentId !== pagePersistentId) {
      throw SupernovaException.shouldNotHappen(`Tried to include invalid analytics data point!`);
    }
  }

  input.priorDataPoints.forEach(validateDataPoint);
  input.currentDataPoints.forEach(validateDataPoint);

  return {
    ...documentationAnalyticsToComparisonDto(input),
    pagePersistentId,
  };
}

//
// Global analytics
//

type GlobalAnalyticsInput = {
  priorDataPoints: PublishedDocPageVisitsEntry[];
  currentDataPoints: PublishedDocPageVisitsEntry[];
  timeFrame: DTODocumentationAnalyticsTimeFrame;
};

export function documentationAnalyticsToComparisonDto(
  input: GlobalAnalyticsInput
): DTOPublishedDocAnalyticsComparisonData {
  const { timeFrame } = input;

  const priorDataPoints = documentationAnalyticsToGlobalDto(input.priorDataPoints);
  const currentDataPoints = documentationAnalyticsToGlobalDto(input.currentDataPoints);

  return {
    timeFrame,
    priorSessionCount: priorDataPoints.reduce((sum, d) => sum + d.sessions, 0),
    priorVisitCount: priorDataPoints.reduce((sum, d) => sum + d.visits, 0),
    currentSessionCount: currentDataPoints.reduce((sum, d) => sum + d.sessions, 0),
    currentVisitCount: currentDataPoints.reduce((sum, d) => sum + d.visits, 0),
  };
}
